import GameWrapper from '../GameWrapper';
import styled, { css } from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color';
import breakpoints from '../../utils/miniBreakpoints';


const {
    linkBlue,
    liveBlue
} = COLORS;

export const LinkWrapper = styled(GameWrapper)`
  text-align: center;

  a {
    font-weight: bold;
  }
  &:hover {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    transform: none;
    box-shadow: none;
  }

  ${({ isRefresh }) => isRefresh ? css`
    display: none !important; // have to use important due to higher specificity from controlled overflow wrapper

    @media (max-width: ${breakpoints.mobile}) {
      height: ${({theme}) => theme.viewAllHeight};
      width: ${({theme}) => theme.width};
      display: flex !important;
      justify-content: center;
      align-items: center;
      margin-top: ${({theme}) => theme.viewMoreLink.marginTop};
      border-radius: ${({theme}) => theme.borderRadius};
      border-width: 1px;

      &:hover {
        border-radius: 6px;
      }
      &&& {
        a {
          font-size: ${({theme}) => theme.viewMoreLink.fontSize};
          color: ${liveBlue} !important;
          height: ${({theme}) => theme.height};
          display: flex !important;
          align-items: center;
          justify-content: center;
          width: ${({theme}) => theme.width};
          > span:not(:last-child)::after {
            margin-right: 5px;
          }
        }
      }
      }
  `
  : css`
    height: 32px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    min-height: initial;
    background-color: ${({ theme: { postseasonTheme: { backgroundColor } = {} } }) => backgroundColor};
    a {
      box-sizing: border-box;
      font-size: 11px;
      color: ${({ theme: { postseasonTheme: { fontColor } = {} } }) => fontColor || linkBlue} !important;
      padding-top: 10px;
      display: inline-block;
    }
    @media (max-width: ${breakpoints.mobile}) {
      border-right: none;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      a {
        padding-top: 25px;
        display: block;
      }
      ${({ isPlayoff }) => isPlayoff ? 'display: none;' : ''}
    }

  `}
`;
